.wrapper {
  margin-right: var(--space-4);
}

@media screen and (max-width: 767px) {
  .wrapper {
    margin-right: var(--space-2);
  }
}